export const siteURL = 'https://api.darusfarm.rs';
export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/v1/`;
